import { render } from "./HFLightTemplate.vue?vue&type=template&id=2f270bda&scoped=true"
import script from "./HFLightTemplate.vue?vue&type=script&lang=js"
export * from "./HFLightTemplate.vue?vue&type=script&lang=js"

import "./HFLightTemplate.vue?vue&type=style&index=0&id=2f270bda&scoped=true&lang=css"

import exportComponent from "C:\\onetap\\onetap\\frontend\\onetapuser\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f270bda"]])

export default __exports__